import { Center, Spinner, Text, VStack } from "@chakra-ui/react"
import React, { useCallback, useState } from "react"
import { AllZoneGroupsQueryVariables, useAllZoneGroupsQuery } from "../../graphql"
import { ZoneGroupsList } from "./ZoneGroupsList"

export const AllZoneGroups: React.FC = () => {
	const [pagination, setPagination] = useState<AllZoneGroupsQueryVariables["pagination"]>({ limit: 20, page: 1 })

	const [{ data, fetching, error }] = useAllZoneGroupsQuery({
		variables: { pagination },
	})

	const nextPage = useCallback(() => {
		if (fetching) return

		if (data?.allZoneGroups.hasNextPage) {
			setPagination((prev) => ({
				...prev,
				page: (prev.page || 0) + 1,
			}))
		}
	}, [data, fetching])

	return (
		<VStack w="full" maxW="2xl" align="stretch">
			{fetching && !data?.allZoneGroups ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading zone groups</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.allZoneGroups.zoneGroups && data.allZoneGroups.zoneGroups.length ? (
				<VStack w="full" align="stretch">
					<Text>
						Showing {data.allZoneGroups.zoneGroups.length || 0} zone group
						{(data.allZoneGroups.zoneGroups.length || 0) > 1 ? "s" : ""}
					</Text>

					<ZoneGroupsList zoneGroups={data.allZoneGroups.zoneGroups} loadMore={nextPage} />

					{fetching && (
						<Center w="full" py="4">
							<VStack w="full" color="grayscale.label">
								<Text fontSize="sm">Loading more zone groups</Text>
								<Spinner size="sm" />
							</VStack>
						</Center>
					)}
				</VStack>
			) : (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						Couldn&apos;t find any zone groups.
					</Text>
				</Center>
			)}
		</VStack>
	)
}
